import { useQuery } from '@tanstack/react-query';
import { meetingsApi } from '@/api/meetings';
import { queryKeys } from '@/query/queryKeys';

type Params = { from: string; to: string };

const useMeetingsQuery = (params: Params, options: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: queryKeys.meetings(params),
    queryFn: () => meetingsApi.listRange(params),
    enabled: (options.enabled ?? true) && Boolean(params.from && params.to),
    staleTime: 60_000,
  });

export { useMeetingsQuery };
